import { render, staticRenderFns } from "./language-texts.vue?vue&type=template&id=8cb53a8c&scoped=true"
import script from "./language-texts.vue?vue&type=script&lang=js"
export * from "./language-texts.vue?vue&type=script&lang=js"
import style0 from "./language-texts.vue?vue&type=style&index=0&id=8cb53a8c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb53a8c",
  null
  
)

export default component.exports